var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucherCheckThanks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0417 16.0117L21.5284 30.9834L17.4117 26.5851C16.6534 25.8701 15.4617 25.8267 14.595 26.4334C13.75 27.0617 13.5117 28.1667 14.0317 29.0551L18.9067 36.9851C19.3834 37.7217 20.2067 38.1767 21.1384 38.1767C22.0267 38.1767 22.8717 37.7217 23.3484 36.9851C24.1284 35.9667 39.0134 18.2217 39.0134 18.2217C40.9634 16.2284 38.6017 14.4734 37.0417 15.9901V16.0117Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherCheckThanks);
export default __webpack_public_path__ + "static/media/voucher-check-thanks.e53edc810ba6ba8d702cc64232b391ed.svg";
export { ForwardRef as ReactComponent };